export { default, DimmedContent, DimmedFooter, DimmedHeader } from './DimmedPopup';
